import React from "react";

import { faCircleInfo } from "@performyard/fontawesome/pro-regular-svg-icons";
import { Checkbox, FormField, Icon, Text, Tooltip } from "@performyard/py-components";

import { LOCK_REVIEWS_INFO, LOCK_REVIEWS_LABEL } from "./constants";

export const LockReviewsField = () => (
	<FormField<boolean>
		id="lockReviews"
		label=""
		input={(field) => (
			<div className="flex items-center gap-1">
				<Checkbox
					id="lockReviews"
					checked={field.value}
					onCheckedChange={field.onChange}
					aria-label={LOCK_REVIEWS_LABEL}
				/>
				<label htmlFor="lockReviews" className="cursor-pointer">
					<Text size="paragraph-3" weight="semi-bold" color="neutral-9">
						{LOCK_REVIEWS_LABEL}
					</Text>
				</label>
				<Tooltip content={LOCK_REVIEWS_INFO}>
					<Icon icon={faCircleInfo} size={16} color="neutral-7" aria-label="More information" />
				</Tooltip>
			</div>
		)}
	/>
);
